import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set page title and meta tags for link previews
document.title = 'QTap WC Smart T-Shirt';
const metaTags = [{
  property: 'og:title',
  content: 'QTap WC Smart T-Shirt'
}, {
  property: 'og:description',
  content: "The world's first NFC-enabled smart t-shirt built for the FIFA World Cup 2026. Tap it with any phone to instantly share your team profile, stats, and exclusive content."
}, {
  property: 'og:type',
  content: 'website'
}, {
  name: 'description',
  content: "The world's first NFC-enabled smart t-shirt built for the FIFA World Cup 2026. Tap it with any phone to instantly share your team profile, stats, and exclusive content."
}];
metaTags.forEach(({
  property,
  name,
  content
}) => {
  const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
  let tag = document.querySelector(selector) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    if (property) tag.setAttribute('property', property);
    if (name) tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
});
(function () {
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  const j = document.createElement('script');
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-T5DQKLPH';
  document.head.appendChild(j);
})();
render(<App data-id="element-702" />, document.getElementById('root'));